class GraniteError extends Error {
  constructor(error, metadata) {
    super(error);
    this.name = this.constructor.name;
    this.stack = new Error(error).stack;
    this.metadata = metadata;
    // GraniteError has a specific format, we capture all unformatted errors
    // and transforms them as "non_field" errors.
    this.errors = error?.errors || error;
    if (this.errors?.field_error?.length) {
      let field_error = {
        title: this.errors.title
      };
      this.errors.field_error.forEach(err => {
        field_error = {
          ...field_error,
          ...err,
          [err.name]: err.reason
        };
      });
      // Object.keys(this.errors.field_error).forEach(key => field_error[key] = this.errors.field_error[key])
      this.errors = field_error;
    }
    if (error && typeof error !== 'object' && error.constructor !== Object) {
      this.errors = {
        non_field: error
      };
    }
  }
}
export default GraniteError;